export enum CaseRecommendationStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export enum ContactableStatus {
  ATTEMPTED_TODAY = 'Attempted Today',
  NOT_ATTEMPTED_TODAY = 'Not Attempted Today'
}

export enum StartResumeCalling {
  START = 'Start Calling',
  RESUME = 'Resume Calling',
  REFRESH = 'All Cases completed. Refresh to collect more cash'
}

export enum PtpStatus {
  YET_TO_MATURE = 'YET_TO_MATURE',
  PARTIALLY_PAID = 'PARTIALLY_PAID',
  DUE_TODAY = 'DUE_TODAY',
  BROKEN_PROMISE = 'BROKEN_PROMISE',
  FULFILLED = 'FULFILLED',
  NO_PTP = 'NO_PTP'
}

export enum PtpStatusLabel {
  YET_TO_MATURE = 'Future PTP',
  PARTIALLY_PAID = 'Partially Paid PTP',
  DUE_TODAY = 'PTP due Today',
  BROKEN_PROMISE = 'Broken Promise',
  FULFILLED = 'Fulfilled PTP',
  NO_PTP = 'No PTP'
}

export enum CaseRecommendationCopy {
  INITIAL_TARGET_MESSAGE = 'Now Easily Achieve your Daily Targets !',
  START_COLLECTIONS = 'Start Collections',
  RESUME_COLLECTIONS = 'Resume Collections',
  COLLECT_MORE_CASH = 'Collect More Cash',
  COMPLETION_MESSAGE = 'Nice work! You have attempted all cases.Hit refresh to maximize your incentive',
  REMAINING_CASES_SUFFIX = 'cases are Left. Hit your target now'
}

export interface RecommendedMetadata {
  totalCases: number;
  visitedCases: number;
  pendingPtps: number;
  lastRefreshedInMs: number;
}

export interface CaseHistory {
  latestDisposition: string;
  ptpState: string;
  isContactable: boolean;
  latestInteractionTimestamp?: number;
  customerName: string;
}

export interface RecommendedCaseDetails {
  caseReferenceId: string;
  isVisited: boolean;
  priority: number;
  attributes: CaseHistory;
}

export interface RecommendedCases {
  lastRefreshedInMs: number;
  caseList: RecommendedCaseDetails[];
}

export interface RecommendedCaseData {
  customerReferenceId: string;
  customerName: string;
  priority: number;
  totalCases: number;
  entityId: string;
  caseReferenceId: string;
  businessVertical: string;
  attributes: CaseHistory;
}

export interface CaseRecommendationState {
  isModalOpen: boolean;
  onStartCallingCallback?: string;
  recommendedCases: RecommendedCases;
  currentRecommendedCase: RecommendedCaseData;
  recommendedMetadata: RecommendedMetadata;
  isLoadingRecommendedCases: boolean;
}

export interface RecommendedListBannerProps {
  primaryText: string;
  secondaryText?: string;
  className?: string;
  onBeforeModalOpen?: () => void;
  imageWidth?: number;
  imageHeight?: number;
  clickstreamEventName: string;
  clickstreamEventDescription: string;
}

export interface params {
  limit: number;
  offset: number;
  successCallback?: () => void;
}

export interface CaseItemProps {
  caseItem: RecommendedCaseDetails;
  index: number;
  totalItems: number;
}
